
export enum UserType {
  Dealer= 'Dealer',
  PeopleTransportOperator= 'PeopleTransportOperator',
  Scrapyard= 'Scrapyard',
  PublicAdministration= 'PublicAdministration',
  Other= 'Other',

}